/* eslint-disable max-len */

import XmrQuestion from 'images/coin-pages/questions/xmr.svg'

import { ICoinPageData } from '../types'

export const xmrPage: ICoinPageData = {
  title: 'coin_1164',
  description: 'coin_1165',
  metaDescription: 'coin_xmr_meta_desc',
  metaTitle: 'coin_xmr_meta_title',
  h1: (t: (key: unknown) => any) => (
    <>
      {t('loan_backed_by')} <span style={{ color: '#f90' }}>Monero</span>
    </>
  ),
  questionsBlock: {
    image: XmrQuestion,
    questions: [
      {
        title: 'coin_1167',
        answer: 'coin_1168',
      },
      {
        title: 'coin_1169',
        answer: 'coin_1170',
      },
      {
        title: 'coin_1171',
        answer: 'coin_1172',
      },
      {
        title: 'coin_1173',
        answer: 'coin_1174',
      },
      {
        title: 'coin_1175',
        answer: 'coin_1176',
      },
    ],
  },
  whatIs: {
    text: [],
    paragraphs: [
      {
        title: 'coin_1177',
        text: ['coin_1181'],
      },
      {
        title: 'coin_1178',
        text: ['coin_1182'],
      },
      {
        title: 'coin_1179',
        text: ['coin_1183', 'coin_1184', 'coin_1185', 'coin_1186', 'coin_1187'],
      },
      {
        title: 'coin_1180',
        text: ['coin_1188', 'coin_1189', 'coin_1190', 'coin_1191', 'coin_1192'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-is-crypto-lending-platform-coinrabbit/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/07/photo_2021-07-23_20-28-31.jpg',
        imageAlt: 'Monero (XMR) review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/crypto-lending-growing-market-emerges-opportunities/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2021/05/photo_2021-05-26_21-10-19.jpg',
        imageAlt: 'Monero (XMR) review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/liquidation-explained-how-to-keep-it-under-control/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/07/integration_9CR_LQ_1.png',
        imageAlt: 'Monero (XMR) review 7',
      },
    ],
  },
}
